(() => {
  if (window.feReuseNavigationBound) return;
  window.feReuseNavigationBound = true;
  const reveal = hash => {
    if (!hash || hash.length < 2) return;
    const target = document.getElementById(hash.slice(1));
    if (!target?.closest('.fe-reuse')) return;
    if (hash === '#comparatie-interna') {
      const radio = document.getElementById('pair-b');
      if (radio) radio.checked = true;
    }
    if (target.matches('[data-reuse-panel]')) target.dispatchEvent(new Event('fe:expand'));
    let parent = target;
    while (parent && parent.closest('.fe-reuse')) {
      if (parent.tagName === 'DETAILS') parent.open = true;
      parent = parent.parentElement;
    }
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('.fe-reuse a[href^="#"]');
    if (link) reveal(link.getAttribute('href'));
  });
  window.addEventListener('hashchange', () => reveal(location.hash));
  customElements.whenDefined('fe-reuse-product-gallery').then(() => reveal(location.hash));
})();
